<template>
  <div class="landing_about">
    <div class="landing_about_text">
      <h1 class="landing_about_header">Welcome to <span>BoomTV</span></h1>
      <div class="landing_about_bar" />
      <p class="landing_about_description">Creators, Clubs and Communities tap us to produce and share esports content. We are also the home of the esports series 'Code Red'.</p>
    </div>
    <div class="landing_about_action">
      <a class="abtn_main" :href="routePubgEvents()">
        <span>Find Events</span>
      </a>
      <a class="abtn_main" :href="routePubgCreateEvent('create')">
        <span>Create Event</span>
      </a>
    </div>
  </div>
</template>

<script>
import { component } from '../../../mixins/component';

export default {
  mixins: [component],
};
</script>
